import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  GetUnpairDeviceFromRfidResponseResponseType,
  UnpairDeviceFromRfidRequestBody,
} from 'redux-store/slices/rfids/types';

const unPairDevicesFromRfidsThunk = createAsyncThunk(
  'organizationOverview/pairDevicesToRfidsThunk',
  async ({
    data,
  }: {
    data: UnpairDeviceFromRfidRequestBody;
  }): Promise<GetUnpairDeviceFromRfidResponseResponseType> => {
    try {
      const apiPointName = 'unPairDevicesFromRfids';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: data,
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default unPairDevicesFromRfidsThunk;
